import { apiRequest } from "./common";

const getSessionList = async (service) => {
    const response = await apiRequest('get', `/ai-session/list${service !== 'all' ? `?service=${service}` : ''}`);
    return response.data;
};

const getMessages = async (chatId) => {
    const response = await apiRequest('get', `/ai-session/${chatId}`);
    return response.data;
};

const startSession = async (data) => {
    const response = await apiRequest('post', `/ai-session`, data);
    return response.data;
};

const updateSession = async (chatId, data) => {
    const response = await apiRequest('patch', `/ai-session/${chatId}`, data);
    return response.data;
};

const sendMessage = async (data) => {
    const response = await apiRequest('post', `/ai-session/message`, data);
    return response.data;
};

const deleteSession = async (chatId) => {
    const response = await apiRequest('delete', `/ai-session/${chatId}`);
    return response.data;
};

export {
    getSessionList,
    getMessages,
    startSession,
    updateSession,
    sendMessage,
    deleteSession
}